module.exports = __webpack_public_path__ + "e93b81bb6d1fdfa128456bd3d2ce0570.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2017/icons/personal-workouts-light.png
// module id = 1874
// module chunks = 1